import { useState, useEffect, useRef } from 'react'
import styles from './GuestBadgeTemplateManager.module.css'
import { useNavigate, useLocation, Link } from 'react-router-dom'

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'

const GuestBadgeTemplateManager = () => {
    const navigate = useNavigate()
	const location = useLocation()
    const passedState = location.state
    // useLocation & useNavigate --- Client state from previous page
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current =passedData
        }
       
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
	return (
        <div id={styles.eventConfigurePage}>
            <h1>Guest Event Badges Template Management</h1><br />
            <h2>Controls guest badge template layout and printing. </h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/GuestBadgeTemplateStyling`} state={clientEventInfo} className={styles.eventLinks} title="Create/edit guest badge templates - style editing.">
                    <h3>Guest Template/Styling Manager</h3>
                </Link>
                <Link to={`/GuestBadgeTemplateFieldOrdering`} state={clientEventInfo} className={styles.eventLinks} title="Guest badge template field layout ordering.">
                    <h3>Guest Badge Template Field Ordering Manager</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default GuestBadgeTemplateManager;